import React, { useState } from 'react'
import { useFormContext } from 'react-hook-form'
import TextInput from '../../../../../shared/Inputs/TextInput/TextInput'
import DatePicker from '../../../../../shared/Inputs/DatePicker/DatePicker'
import { UPLOADS_ENDPOINT } from '../../../../../server-parameters'
import { yearsAgo } from '../../../../../utils/helpers'
import {
  validateName,
  validateDate,
  passportDigits,
  passportText,
  smartValidateString,
} from '../../../../../validate/validators'
import { Country, Lang } from '../../../../../types/common-types'
import { State } from '../../../../../state-actions-reducers'
import FileInput from '../../../../../shared/Inputs/FileInput/FileInput'
import { PassportType } from '../../../../../enums/passportTypeEnum'

export default function BelarusForm({
  lang,
  accountForm,
}: { lang: Lang; accountForm: any }) {
  const { watch, setValue, getValues, formState: { errors } } = useFormContext<State>()
  const state = watch()
  const [focus, setFocus] = useState('')
  return (
    <>
      {Number(state.passportType) === PassportType.ResidencePermit ? (
        <>
          <div className="col-2 col-xs-12">
            {/* PASSPORT PERMANENT RESIDENCY DATE */}
            <DatePicker
              testName={'passportDateIssuePermanentResidency'}
              testErrorName={'error-passportDateIssuePermanentResidency'}
              disabled={!state.agreed}
              lang={lang}
              accountForm={accountForm}
              accountFormKey="passportDateIssuePermanentResidency"
              onChange={data =>
                setValue('passportDateIssuePermanentResidency', data, { shouldDirty: true })
              }
              value={state.passportDateIssuePermanentResidency}
              required
              valid={
                !errors.passportDateIssuePermanentResidency &&
                validateDate({
                  current: state.passportDateIssuePermanentResidency,
                  min: yearsAgo(130),
                  max: new Date(),
                })
              }
              onBlur={() => setFocus('')}
              min={
                new Date(new Date().setFullYear(new Date().getFullYear() - 10))
              }
              max={new Date()}
            />
          </div>
          <div className="col-8 col-xs-12">
            {/* ISSUED BY */}
            <TextInput
              testName={'passportIssuedBy'}
              testErrorName={'error-passportIssuedBy'}
              disabled={!state.agreed}
              lang={lang}
              content={accountForm.issuedBy}
              onChange={passportIssuedBy =>
                setValue('passportIssuedBy', passportIssuedBy.toLocaleUpperCase(), { shouldDirty: true })
              }
              value={state.passportIssuedBy}
              required
              valid={
                !errors.passportIssuedBy
              }
              onBlur={() => setFocus('')}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport'}
              testErrorName={'error-F_Scan_Directors_Passport'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.residenceFileMainFiscal}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport', [...(getValues('F_Scan_Directors_Passport')||[]), data], { shouldDirty: true })
              }}
              valid={!errors.F_Scan_Directors_Passport}
              documentType="Passport1"
              value={
                state.F_Scan_Directors_Passport[
                  state.F_Scan_Directors_Passport.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
          <div className="col-4 col-xs-12">
            <FileInput
              testName={'F_Scan_Directors_Passport_Address'}
              testErrorName={'error-F_Scan_Directors_Passport_Address'}
              disabled={!state.agreed}
              lang={lang}
              url={UPLOADS_ENDPOINT}
              autorization={state.formId}
              target={state.documentsImages}
              content={accountForm.residenceFileSecondFiscal}
              
              onChange={data => {
                setValue('F_Scan_Directors_Passport_Address', [...(getValues('F_Scan_Directors_Passport_Address')||[]), data], { shouldDirty: true })
              }}
              valid={
                !errors.F_Scan_Directors_Passport_Address
              }
              documentType="Passport2"
              value={
                state.F_Scan_Directors_Passport_Address[
                  state.F_Scan_Directors_Passport_Address.length - 1
                ]
              }
              imageErrors={state.imageError}
            />
          </div>
        </>
      ) : null}
    </>
  )
}
